import request from '@/assets/js/request'
export function login (params) {
    return request({
        url: '/api/wechat/login',
        method: 'get',
        params
    })
}
export function register (data) {
    return request({
        url: '/api/user/register',
        method: 'post',
        type: 'json',
        data
    })
}
export function imageFileUploadNoScale (data) {
    return request({
        url: '/api/file/imageFileUploadNoScale',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/auth.js